import React, { useLayoutEffect } from "react";
import Headline from "../../Headline/Headline";
import { useIntl } from "react-intl";

import Section from "../../UI/Others/Section";
import Balloon from "../../UI/Others/balloon";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faAndroid, faAppStoreIos, faWindows, faChrome } from "@fortawesome/free-brands-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const StoreCard = (props) => {
    const intl = useIntl();

    return (
        <div className="d-flex col-xs-12 col-md-6 col-xl-4">
            <div className="card">
                <div className="pt-5 pb-3">
                    <Balloon color={props.colorIcon} icon={props.icon} />
                </div>

                <div className="card-body mt-3">
                    <h4 className="card-title">{props.title}</h4>
                    <div className="card-subtitle">
                        <p className="m-0">{props.subtitle}</p>
                        <p>{intl.messages.storeAutor}: <b>{props.author}</b></p>
                    </div>
                    <div className="card-text">{props.children}</div>
                </div>

                <div className="card-footer text-left">
                    <a className={"btn btn-link btn-link-"+ props.colorIcon} 
                        href={props.link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faArrowRight} className={"mr-2 icon-" + props.colorIcon} />
                        {intl.messages.install}</a>
                </div>

            </div>
        </div>
    );
}

const Store = () => {

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    const intl = useIntl();

    const title = intl.messages.storeTitle;
    const subtitle = intl.messages.storeMessage;

    return (
        <div id="store">
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-text">{intl.messages.storeOverview}</div>
                    </div>
                </div>
            </div>

            <Section 
                title={intl.messages.storeApplications} 
                className="bg-blue"
            />

            <div className="row">
                <StoreCard
                    title={"Rainbow " + intl.messages.for + " Windows"}
                    subtitle="Microsoft application"
                    author="ALE Enterprise"
                    icon={faWindows}
                    colorIcon="blue"
                    link="https://web.openrainbow.com/downloads/Rainbow_Installer.exe"
                ></StoreCard>

                <StoreCard
                    title={"Rainbow " + intl.messages.for + " macOS"}
                    subtitle="Apple application"
                    author="ALE Enterprise"
                    icon={faApple}
                    colorIcon="violet"
                    link="https://web.openrainbow.com/downloads/Rainbow_Installer.dmg"
                ></StoreCard>

                <StoreCard
                    title={"Rainbow " + intl.messages.for + " iOS"}
                    subtitle="Apple application"
                    author="ALE Enterprise"
                    icon={faAppStoreIos}
                    colorIcon="pink"
                    link="https://itunes.apple.com/us/app/ale-rainbow/id1053514112"
                ></StoreCard>

                <StoreCard
                    title={"Rainbow " + intl.messages.for + " Android"}
                    subtitle="Google application"
                    author="ALE Enterprise"
                    icon={faAndroid}
                    colorIcon="sky"
                    link="https://play.google.com/store/apps/details?id=com.ale.rainbow"
                ></StoreCard>
            </div>

            <Section 
                title={intl.messages.storeConnectors} 
                className="bg-orange"
            />

            <div className="row">
                <StoreCard
                    title={"Rainbow Click2Call " + intl.messages.for + " Google Chrome"}
                    subtitle="Google chrome extension"
                    author="ALE Enterprise"
                    icon={faChrome}
                    colorIcon="orange"
                    link="https://chrome.google.com/webstore/detail/rainbow-click2call/oghmpbfpplffokeiljfeadlgjbejnghd?hl=fr"
                >
                    <h6>{intl.formatMessage({ id: "storeClick2CallTitle" }, { b: chunks => <b>{chunks}</b> })}</h6>
                    <p>{intl.formatMessage({ id: "storeClick2CallMsg" }, { b: chunks => <b>{chunks}</b> })}</p>
                </StoreCard>

                <StoreCard
                    title={"Rainbow Telephony " + intl.messages.for + " Microsoft Teams"}
                    subtitle="Microsoft Teams PowerApp"
                    author="ALE Enterprise"
                    icon={faWindows}
                    colorIcon="orange"
                    link="https://web.openrainbow.com/downloads/Rainbow_for_Teams_Online_Installer_User_mode.exe"
                >
                    <h6>{intl.formatMessage({ id: "storeConnectorTitle" }, { b: chunks => <b>{chunks}</b> })}</h6>
                    <p>{intl.formatMessage({ id: "storeConnectorMsg" }, { b: chunks => <b>{chunks}</b> })}</p>
                </StoreCard>
            </div>


        </div>
    );

}

export default Store
